import React, { useState, useEffect, useCallback } from "react";
import { Table, Input, Spin, Select, Space } from "antd";
import api from "../../../api/index";
import moment from "moment";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import TotalPnlReportsModal from "../Tab-1/Modal/TotalPnlReportsModal";
import { get } from "lodash";
import OneInvoiceModal from "../Tab-1/Modal/OneInvoiceModal/index";
import TotalInvoicesModal from "../Tab-1/Modal/TotalInvoicesModal/index";

const today = moment().format("YYYY-MM-DD");

export default function Tab2() {
	const [invoices, setInvoices] = useState([]);

	const [pnlReports, setPnlReports] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingPnl, setLoadingPnl] = useState(false);
	const [salesAnalysisData, setSalesAnalysisData] = useState([]);
	const [salesAnalysGrp, setSalesAnalysGrp] = useState("");
	const [currentPageSales, setCurrentPageSales] = useState(0);
	const [startDatePnl, setStartDatePnl] = useState(moment().startOf("year").format("YYYY-MM-DD"));
	const [endDatePnl, setEndDatePnl] = useState(today);
	const [whsPnl, setWhsPnl] = useState("");
	const [whsSalesAnalysis, setWhsSalesAnalysis] = useState("");
	const [activeTab, setActiveTab] = useState("tab1");
	const [debtors, setDebtors] = useState([]);
	const [cashs, setCashs] = useState([]);
	const [whsOptions, setWhsOptions] = useState([]);
	const [whsLoading, setWhsLoading] = useState(false);
	const [pnlData, setPnlData] = useState([]);
	const [pnlModal, setPnlModal] = useState(false);
	const [periodCharts, setPeriodCharts] = useState("weekly");
	const [loadingCharts, setLoadingCharts] = useState(false);
	const [isTotalInvoiceModalOpen, setIsTotalInvoiceModalOpen] = useState(false);
	const [clickedInvoice, setClickedInvoice] = useState(null);
	const [invoiceModal, setInvoiceModal] = useState(false);
	const [reportsData, setReportsData] = useState([]);
	const [salesChartsData, setSalesChartsData] = useState({
		labels: [],
		datasets: [],
	});
	const [expensesChartsData, setExpensesChartsData] = useState({
		labels: [],
		datasets: [],
	});
	const [profitChartsData, setProfitChartsData] = useState({
		labels: [],
		datasets: [],
	});
	const [stockPricesCharts, setStockPricesCharts] = useState({
		labels: [],
		datasets: [],
	});
	const [grossProfitCharts, setGrossProfitCharts] = useState({
		labels: [],
		datasets: [],
	});

	const renderContent = () => {
		switch (activeTab) {
			case "tab1":
				return (
					<div className="h-full min-h-full w-full mx-auto min-w-[1000px]  ">
						<h2 className="text-xl font-bold mb-4">Sotuvlar</h2>
						{salesChartsData?.datasets?.length > 0 ? (
							<Line data={salesChartsData} options={options} />
						) : (
							<div className="text-lg text-center">No data available</div>
						)}
					</div>
				);
			case "tab2":
				return (
					<div className="h-full min-h-full w-full mx-auto min-w-[1000px]  ">
						<h2 className="text-xl font-bold mb-4">Tannarx</h2>
						{stockPricesCharts?.datasets?.length > 0 ? (
							<Line data={stockPricesCharts} options={options} />
						) : (
							<div className="text-lg text-center">No data available</div>
						)}
					</div>
				);
			case "tab3":
				return (
					<>
						<div className="h-full min-h-full w-full mx-auto min-w-[1000px]  ">
							<h2 className="text-xl font-bold mb-4">Yalpi foyda</h2>
							{profitChartsData?.datasets?.length > 0 ? (
								<Line data={profitChartsData} options={options} />
							) : (
								<div className="text-lg text-center">No data available</div>
							)}
						</div>
					</>
				);
			case "tab4":
				return (
					<div className="h-full min-h-full w-full mx-auto min-w-[1000px]  ">
						<h2 className="text-xl font-bold mb-4">Xarajatlar</h2>
						{expensesChartsData?.datasets?.length > 0 ? (
							<Line data={expensesChartsData} options={options} />
						) : (
							<div className="text-lg text-center">No data available</div>
						)}
					</div>
				);
			case "tab5":
				return (
					<div className="h-full min-h-full w-full mx-auto min-w-[1000px]  ">
						<h2 className="text-xl font-bold mb-4">Sof foyda</h2>
						{grossProfitCharts?.datasets?.length > 0 ? (
							<Line data={grossProfitCharts} options={options} />
						) : (
							<div className="text-lg text-center">No data available</div>
						)}
					</div>
				);
			default:
				return null;
		}
	};

	const options = {
		responsive: true,
		plugins: {
			legend: {
				position: "top",
			},
		},
		scales: {
			x: {
				beginAtZero: true,
			},
			y: {
				beginAtZero: true,
				grid: {
					display: false, // Hides horizontal grid lines
				},
			},
		},
	};

	const colorPairs = [
		{ bg: "rgba(59, 130, 246, 0.2)", border: "rgb(59, 130, 246)" }, // Blue
		{ bg: "rgba(220, 38, 38, 0.2)", border: "rgb(220, 38, 38)" }, // Red
		{ bg: "rgba(16, 185, 129, 0.2)", border: "rgb(16, 185, 129)" }, // Green
		{ bg: "rgba(245, 158, 11, 0.2)", border: "rgb(245, 158, 11)" }, // Yellow
		{ bg: "rgba(139, 92, 246, 0.2)", border: "rgb(139, 92, 246)" }, // Purple
		{ bg: "rgba(236, 72, 153, 0.2)", border: "rgb(236, 72, 153)" }, // Pink
		{ bg: "rgba(14, 165, 233, 0.2)", border: "rgb(14, 165, 233)" }, // Sky
		{ bg: "rgba(168, 85, 247, 0.2)", border: "rgb(168, 85, 247)" }, // Violet
		{ bg: "rgba(251, 146, 60, 0.2)", border: "rgb(251, 146, 60)" }, // Orange
		{ bg: "rgba(20, 184, 166, 0.2)", border: "rgb(20, 184, 166)" }, // Teal
		{ bg: "rgba(234, 88, 12, 0.2)", border: "rgb(234, 88, 12)" }, // Orange-Dark
		{ bg: "rgba(22, 163, 74, 0.2)", border: "rgb(22, 163, 74)" }, // Green-Dark
		{ bg: "rgba(190, 18, 60, 0.2)", border: "rgb(190, 18, 60)" }, // Rose
		{ bg: "rgba(79, 70, 229, 0.2)", border: "rgb(79, 70, 229)" }, // Indigo
		{ bg: "rgba(147, 51, 234, 0.2)", border: "rgb(147, 51, 234)" }, // Purple-Dark
		{ bg: "rgba(6, 182, 212, 0.2)", border: "rgb(6, 182, 212)" }, // Cyan
		{ bg: "rgba(202, 138, 4, 0.2)", border: "rgb(202, 138, 4)" }, // Yellow-Dark
		{ bg: "rgba(124, 58, 237, 0.2)", border: "rgb(124, 58, 237)" }, // Violet-Dark
		{ bg: "rgba(159, 18, 57, 0.2)", border: "rgb(159, 18, 57)" }, // Ruby
		{ bg: "rgba(47, 132, 4, 0.2)", border: "rgb(47, 132, 4)" }, // Forest
	];

	useEffect(() => {
		getWarehouses();
		getReports();
	}, []);

	useEffect(() => {
		getSalesAnalysis(salesAnalysGrp, whsSalesAnalysis);
	}, [salesAnalysGrp, whsSalesAnalysis]);

	useEffect(() => {
		getPnlReports(startDatePnl, endDatePnl, whsPnl);
		getInvoices(startDatePnl, endDatePnl, whsPnl);
	}, [startDatePnl, endDatePnl, whsPnl]);

	useEffect(() => {
		getSalesCharts(periodCharts, whsPnl);
		getExpensesCharts(periodCharts, whsPnl);
		getProfitCharts(periodCharts, whsPnl);
		getStockPricesCharts(periodCharts, whsPnl);
		getGrossProfitCharts(periodCharts, whsPnl);
	}, [periodCharts, whsPnl]);

	const getPnlReports = async (startDate, endDate, whs) => {
		try {
			await api
				.get(`api/marioliva/pnlreport?startDate=${startDate}&endDate=${endDate}&whsName=${whs}`)
				.then((res) => {
					const resData = JSON.parse(res.data);
					setPnlReports(resData);
					setPnlData(
						resData
							.filter(
								(cash) =>
									cash.acctName !== "Sotuv" &&
									cash.acctName !== "Yalpi Foyda" &&
									cash.acctName !== "Sof Foyda" &&
									cash.acctName !== "Jami Tannarx" &&
									cash.acctName !== "Jami Sotuv"
							)
							?.map((cash) => cash)
					);
				});
		} catch (error) {
			console.error(error.message);
		}
	};

	const getReports = async () => {
		try {
			await api.get(`api/marioliva/reports/marioliva`).then((res) => {
				const resData = JSON.parse(res.data);
				setReportsData(resData);
			});
		} catch (error) {
			console.error(error.message);
		}
	};

	const getSalesCharts = async (period, whsName) => {
		setLoadingCharts(true);

		try {
			const { data } = await api.get(
				`api/marioliva/salescharts?period=${period}&whsName=${whsName}`
			);

			if (!data) {
				throw new Error("No data received from the API");
			}

			const formattedData = JSON.parse(data);

			if (!formattedData || !Array.isArray(formattedData)) {
				throw new Error("Invalid data format received");
			}

			const formattedDates = formattedData
				.map((item) => item?.documentLines?.map((line) => line?.salesDocDate))
				.filter((dates) => dates)
				.flat()
				.filter((date) => date)
				.sort((a, b) => new Date(a) - new Date(b));

			const uniqueDates = Array.from(new Set(formattedDates));

			const datasets = formattedData
				.filter((item) => item?.documentLines)
				.map((item, index) => ({
					label: item.whsName || `Dataset ${index + 1}`,
					data: item.documentLines.map((line) => line?.salesDocTotal || 0),
					fill: true,
					backgroundColor: colorPairs[index].bg,
					borderColor: colorPairs[index].border,
					tension: 0.4,
				}));

			setSalesChartsData({
				labels: uniqueDates,
				datasets: datasets,
			});
		} catch (error) {
			console.error("Error fetching sales data:", error.message);
		} finally {
			setLoadingCharts(false);
		}
	};

	const getExpensesCharts = async (period, whsName) => {
		setLoadingCharts(true);

		try {
			const { data } = await api.get(
				`api/marioliva/expensescharts?period=${period}&whsName=${whsName}`
			);

			if (!data) {
				throw new Error("No data received from the API");
			}

			const formattedData = JSON.parse(data);

			if (!formattedData || !Array.isArray(formattedData)) {
				throw new Error("Invalid data format received");
			}

			const formattedDates = formattedData
				.map((item) => item?.documentLines?.map((line) => line?.expensesDocDate))
				.filter((dates) => dates)
				.flat()
				.filter((date) => date)
				.sort((a, b) => new Date(a) - new Date(b));

			const uniqueDates = Array.from(new Set(formattedDates));

			const datasets = formattedData
				.filter((item) => item?.documentLines)
				.map((item, index) => ({
					label: item.whsName || `Dataset ${index + 1}`,
					data: item.documentLines.map((line) => line?.expensesDocTotal || 0),
					fill: true,
					backgroundColor: colorPairs[index].bg,
					borderColor: colorPairs[index].border,
					tension: 0.4,
				}));

			setExpensesChartsData({
				labels: uniqueDates,
				datasets: datasets,
			});
		} catch (error) {
			console.error("Error fetching sales data:", error.message);
		} finally {
			setLoadingCharts(false);
		}
	};

	const getProfitCharts = async (period, whsName) => {
		setLoadingCharts(true);

		try {
			const { data } = await api.get(
				`api/marioliva/profitscharts?period=${period}&whsName=${whsName}`
			);

			if (!data) {
				throw new Error("No data received from the API");
			}

			const formattedData = JSON.parse(data);

			if (!formattedData || !Array.isArray(formattedData)) {
				throw new Error("Invalid data format received");
			}

			const formattedDates = formattedData
				.map((item) => item?.documentLines?.map((line) => line?.profitsDocDate))
				.filter((dates) => dates)
				.flat()
				.filter((date) => date)
				.sort((a, b) => new Date(a) - new Date(b));

			const uniqueDates = Array.from(new Set(formattedDates));

			const datasets = formattedData
				.filter((item) => item?.documentLines)
				.map((item, index) => ({
					label: item.whsName || `Dataset ${index + 1}`,
					data: item.documentLines.map((line) => line?.profitsDocTotal || 0),
					fill: true,
					backgroundColor: colorPairs[index].bg,
					borderColor: colorPairs[index].border,
					tension: 0.4,
				}));

			setProfitChartsData({
				labels: uniqueDates,
				datasets: datasets,
			});
		} catch (error) {
			console.error("Error fetching sales data:", error.message);
		} finally {
			setLoadingCharts(false);
		}
	};

	const getGrossProfitCharts = async (period, whsName) => {
		setLoadingCharts(true);

		try {
			const { data } = await api.get(
				`api/marioliva/netprofitscharts?period=${period}&whsName=${whsName}`
			);

			if (!data) {
				throw new Error("No data received from the API");
			}

			const formattedData = JSON.parse(data);

			if (!formattedData || !Array.isArray(formattedData)) {
				throw new Error("Invalid data format received");
			}

			const formattedDates = formattedData
				.map((item) => item?.documentLines?.map((line) => line?.netProfitsDocDate))
				.filter((dates) => dates)
				.flat()
				.filter((date) => date)
				.sort((a, b) => new Date(a) - new Date(b));

			const uniqueDates = Array.from(new Set(formattedDates));

			const datasets = formattedData
				.filter((item) => item?.documentLines)
				.map((item, index) => ({
					label: item.whsName || `Dataset ${index + 1}`,
					data: item.documentLines.map((line) => line?.netProfitsDocTotal || 0),
					fill: true,
					backgroundColor: colorPairs[index].bg,
					borderColor: colorPairs[index].border,
					tension: 0.4,
				}));

			setGrossProfitCharts({
				labels: uniqueDates,
				datasets: datasets,
			});
		} catch (error) {
			console.error("Error fetching sales data:", error.message);
		} finally {
			setLoadingCharts(false);
		}
	};

	const getStockPricesCharts = async (period, whsName) => {
		setLoadingCharts(true);

		try {
			const { data } = await api.get(
				`api/marioliva/stockpricescharts?period=${period}&whsName=${whsName}`
			);

			if (!data) {
				throw new Error("No data received from the API");
			}

			const formattedData = JSON.parse(data);

			if (!formattedData || !Array.isArray(formattedData)) {
				throw new Error("Invalid data format received");
			}

			const formattedDates = formattedData
				.map((item) => item?.documentLines?.map((line) => line?.stockPricesDocDate))
				.filter((dates) => dates)
				.flat()
				.filter((date) => date)
				.sort((a, b) => new Date(a) - new Date(b));

			const uniqueDates = Array.from(new Set(formattedDates));

			const datasets = formattedData
				.filter((item) => item?.documentLines)
				.map((item, index) => ({
					label: item.whsName || `Dataset ${index + 1}`,
					data: item.documentLines.map((line) => line?.stockPricesDocTotal || 0),
					fill: true,
					backgroundColor: colorPairs[index].bg,
					borderColor: colorPairs[index].border,
					tension: 0.4,
				}));

			setStockPricesCharts({
				labels: uniqueDates,
				datasets: datasets,
			});
		} catch (error) {
			console.error("Error fetching sales data:", error.message);
		} finally {
			setLoadingCharts(false);
		}
	};

	const getInvoices = async (startDate, endDate, whs) => {
		setLoadingPnl(true);
		try {
			await api
				.get(
					`api/marioliva/sales/sotuvlar?startDate=${startDate}&endDate=${endDate}&whsName=${whs}`
				)
				.then((res) => {
					setInvoices(JSON.parse(res.data));
				});
		} catch (error) {
			console.error(error.message);
		} finally {
			setLoadingPnl(false);
		}
	};

	const handleInputChangeSalesAnalys = useCallback((value) => {
		setCurrentPageSales(0);
		setSalesAnalysGrp(value);
	}, []);

	const getSalesAnalysis = async (itmGrp, whsName) => {
		setLoading(true);
		try {
			await api
				.get(`api/marioliva/salesanalysis?groupName=${itmGrp}&whsName=${whsName}`)
				.then((res) => {
					setSalesAnalysisData(JSON.parse(res.data));
				});
		} catch (error) {
			console.error(error.message);
		}
		setLoading(false);
	};

	const getWarehouses = async () => {
		setWhsLoading(true);
		try {
			await api.get("api/marioliva/inventoryitems/warehouses").then((res) => {
				setWhsOptions([
					{
						label: "Umumiy",
						value: "",
					},
					...JSON.parse(res.data).map((warehouse) => {
						return {
							label: warehouse.whsName,
							value: warehouse.whsName,
						};
					}),
				]);
			});
		} catch (error) {
			console.error(error.message);
		} finally {
			setWhsLoading(false);
		}
	};

	const salesAnalysColumns = [
		{
			title: "Mahsulot guruhi",
			dataIndex: "group",
			key: "group",
			filterDropdown: ({ confirm, dataIndex }) => (
				<div className="p-2">
					<Input
						placeholder="Mahsulot bo'yicha qidirish"
						value={salesAnalysGrp}
						onChange={(e) => {
							handleInputChangeSalesAnalys(e.target.value ? e.target.value : "");
							// handleSearch(e, confirm, dataIndex);
						}}
						style={{ width: 200, marginBottom: 8, display: "block" }}
					/>
				</div>
			),
			onFilter: (value, record) => record.group === value,
		},

		{
			title: "Soni",
			dataIndex: "quantity",
			key: "quantity",
			text: "center",
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "   ");
				return `${formattedText}`;
			},
			sorter: (a, b) => a.quantity - b.quantity,
		},
		{
			title: "Summa",
			dataIndex: "sales",
			key: "sales",
			text: "center",
			sorter: (a, b) => a.sales - b.sales,

			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "   ");
				return `${formattedText}`;
			},
		},
		{
			title: "Foyda",
			dataIndex: "profit",
			key: "profit",
			text: "center",
			sorter: (a, b) => a.profit - b.profit,

			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "   ");
				return `${formattedText}`;
			},
		},
		{
			title: "Foyda foizda",
			dataIndex: "grossPercent",
			key: "grossPercent",
			sorter: (a, b) => a.grossPercent - b.grossPercent,

			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "   ");
				return `${formattedText} %`;
			},
		},
	];

	return (
		<>
			<h1 className="text-lg mt-10 font-semibold ml-2">P&L</h1>
			<div className="flex items-center gap-2 sm:gap-8 mt-5">
				<div className="flex flex-col gap-2">
					<p>Boshlang'ich sana</p>
					<Input
						type="date"
						value={startDatePnl}
						className="w-[150px]"
						onChange={(e) => {
							setStartDatePnl(e.target.value);
						}}
						max={endDatePnl}
					/>
				</div>
				<div className="flex flex-col gap-2">
					<p>Tugash sanasi</p>
					<Input
						type="date"
						value={endDatePnl}
						className="w-[150px]"
						onChange={(e) => {
							setEndDatePnl(e.target.value);
						}}
						min={startDatePnl}
					/>
				</div>
				<div className="flex flex-col gap-2">
					<p>Do'kon</p>
					<Select
						className="w-[250px]"
						value={whsPnl}
						onChange={(value) => setWhsPnl(value)}
						options={whsOptions}
						loading={whsLoading}
					/>
				</div>
			</div>
			{loadingPnl ? (
				<div className="flex items-center justify-center mt-5">
					<Spin />
				</div>
			) : (
				<>
					<div className="grid grid-cols-1 sm:grid-cols-2  lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 3xl:grid-cols-6 gap-5 mt-10">
						{invoices
							?.filter((invoice) => {
								return whsPnl === "" ? invoice.whsName === "Umumiy" : invoice.whsName === whsPnl;
							})
							?.map((invoice, idx) => {
								return (
									<>
										<div
											className="flex h-[120px]  w-full  sm:w-[250px] flex-col gap-4 items-center rounded-3xl bg-white drop-shadow-xl"
											key={idx}
											onClick={() => {
												setIsTotalInvoiceModalOpen(invoice.whsName === "Umumiy" ? true : false);
												setInvoiceModal(invoice.whsName !== "Umumiy" ? true : false);
												setClickedInvoice(invoice);
											}}
										>
											<h1 className="font-poppins  mt-5 text-center text-xl font-bold text-[#425166]">
												{invoice.whsName === "Umumiy" ? "Umumiy Sotuvlar" : invoice.whsName}
											</h1>
											<div>
												<h1 className="font-poppins  text-xl font-bold text-[#151D48]">
													{" "}
													{new Intl.NumberFormat("fr-FR")
														.format(invoice.salesDocTotal)
														.replace(/\s/g, "  ")}{" "}
												</h1>
											</div>
										</div>
									</>
								);
							})}
						{pnlReports
							?.filter(
								(cash) =>
									(cash.acctName !== "Sotuv" && cash.acctName === "Yalpi Foyda") ||
									cash.acctName === "Jami Tannarx" ||
									cash.acctName === "Umumiy Chiqimlar" ||
									cash.acctName === "Sof Foyda"
							)
							?.map((cash, idx) => {
								return (
									<div
										className="flex h-[120px] w-full  sm:w-[250px] flex-col gap-4 items-center rounded-3xl bg-white drop-shadow-xl"
										onClick={() => {
											setPnlModal(cash.acctName === "Umumiy Chiqimlar" ? true : false);
										}}
									>
										<h1 className="font-poppins  mt-5 text-xl font-bold text-[#425166]">
											{cash.acctName === "Arrenda do'kon (toshmi)"
												? "Arenda do'kon (toshmi)"
												: cash.acctName === "SofFoyda"
												? "Sof foyda"
												: cash.acctName === "Umumiy Rasxodlar"
												? "Umumiy Chiqimlar"
												: cash.acctName === "Arrenda do'kon (archa)"
												? "Arenda do'kon (archa)"
												: cash.acctName.replace(/rasxod/g, "chiqim")}
										</h1>

										<h1 className="font-poppins  text-xl font-bold text-[#151D48]">
											{" "}
											{new Intl.NumberFormat("fr-FR").format(cash.summa).replace(/\s/g, "  ")}{" "}
										</h1>
									</div>
								);
							})}
					</div>
				</>
			)}
			<div className="mt-10 mb-10 w-full ">
				<Space style={{ marginBottom: 16 }} className="mt-10 ">
					<button
						className={`${
							activeTab === "tab1" ? "text-blue-900 underline underline-offset-8" : ""
						} font-semibold `}
						onClick={() => setActiveTab("tab1")}
					>
						Sotuvlar
					</button>
					<button
						className={`${
							activeTab === "tab2" ? "text-blue-900 underline underline-offset-8" : ""
						} font-semibold ml-3`}
						onClick={() => setActiveTab("tab2")}
					>
						Tannarx
					</button>
					<button
						className={`${
							activeTab === "tab3" ? "text-blue-900 underline underline-offset-8" : ""
						} font-semibold ml-3`}
						onClick={() => setActiveTab("tab3")}
					>
						Yalpi foyda
					</button>
					<button
						className={`${
							activeTab === "tab4" ? "text-blue-900 underline underline-offset-8" : ""
						} font-semibold ml-3`}
						onClick={() => setActiveTab("tab4")}
					>
						Xarajatlar
					</button>
					<button
						className={`${
							activeTab === "tab5" ? "text-blue-900 underline underline-offset-8" : ""
						} font-semibold ml-3`}
						onClick={() => setActiveTab("tab5")}
					>
						Sof foyda
					</button>
				</Space>
				<div>
					<Select
						className="flex   items-center  justify-center w-[250px]"
						onChange={(val) => {
							setPeriodCharts(val);
						}}
						loading={loading}
						value={periodCharts}
						options={[
							{
								value: "weekly",
								label: "Haftalik",
							},
							{
								value: "monthly",
								label: "Oylik",
							},
							{
								value: "yearly",
								label: "Yillik",
							},
							{
								value: "twoYears",
								label: "Oldingi yilgi",
							},
						]}
					/>
					<Spin size="large" spinning={loadingCharts}>
						<div className="mt-10 overflow-x-scroll">{renderContent()}</div>
					</Spin>
				</div>
			</div>
			{whsPnl === "Cклад Основной МариМолоко" && (
				<>
					<div className="grid grid-cols-1 sm:grid-cols-2  lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 3xl:grid-cols-6 gap-5 mt-10">
						{reportsData.map((cash, idx) => {
							return (
								<div className="flex h-[120px] w-full  sm:w-[250px] flex-col gap-4 items-center rounded-3xl bg-white drop-shadow-xl">
									<h1 className="font-poppins  mt-5 text-xl font-bold text-[#425166]">
										{cash?.name}
									</h1>

									<h1 className="font-poppins  text-xl font-bold text-[#151D48]">
										{" "}
										{new Intl.NumberFormat("fr-FR").format(cash.summa).replace(/\s/g, "  ")}{" "}
									</h1>
								</div>
							);
						})}
					</div>
				</>
			)}
			<div>
				<div className="flex items-center gap-8 mt-10 ">
					<h1 className="text-lg font-semibold">Sotuv analizi </h1>
					<Select
						className="w-[250px]"
						value={whsSalesAnalysis}
						onChange={(value) => setWhsSalesAnalysis(value)}
						options={whsOptions}
					/>
				</div>
				<Table
					columns={salesAnalysColumns}
					dataSource={salesAnalysisData}
					pagination={false}
					className="mt-6 w-full"
					bordered
					sticky={true}
					loading={loading}
					// onChange={handleTableChange}
				/>
			</div>
			<TotalPnlReportsModal visible={pnlModal} data={pnlData} onClose={() => setPnlModal(false)} />
			<OneInvoiceModal
				visible={invoiceModal}
				data={clickedInvoice}
				onClose={() => setInvoiceModal(false)}
			/>

			<TotalInvoicesModal
				visible={isTotalInvoiceModalOpen}
				data={invoices}
				onClose={() => {
					setIsTotalInvoiceModalOpen(false);
				}}
			/>
		</>
	);
}
